import { HubModuleDefaultView, HubModuleLayout, IEventsBaseModuleDTO, TCreateHubModuleDTO } from '../../../../../../../../api/event-hubs.dao';
import {
    DEFAULT_VIEW,
    DESCRIPTION,
    DISPLAY_LABEL,
    DISPLAY_PAST_EVENTS,
    DISPLAY_SPEAKERS,
    DISPLAY_UPCOMING_EVENTS,
    LABEL,
    LAYOUT,
    PAST_EVENTS_DAYS,
    POSITION_ORDER,
    UPCOMING_EVENTS_DAYS,
} from './events-base.config';
import { HubModuleVM } from '../hub-module.viewmodel';
import { transpileClassesToInlineStyles, transpileInlineStylesToClasses } from '../../../../../../../global/rich-text-editor/utils/transpiler';

export abstract class EventsBaseModuleVM extends HubModuleVM {
    public clone = (): EventsBaseModuleVM => {
        const dto = this.isNew() ? this.toCreateDTO() : this.toUpdateDTO();
        const vm = this.cloneFromDTO(dto);
        this.copyIdentityTo(vm);
        return vm;
    };

    public isValid(): boolean {
        return this.isVmValid() && this.hasValidEventsDisplayConfig();
    }

    public hasValidEventsDisplayConfig = (): boolean => {
        return this.getBooleanValue(DISPLAY_UPCOMING_EVENTS) || this.getBooleanValue(DISPLAY_PAST_EVENTS);
    };

    public isDefaultViewHidden = (): boolean => {
        return this.getFormVmValuePropsByKey(LAYOUT).value === HubModuleLayout.LIST;
    };

    protected abstract cloneFromDTO(dto: TCreateHubModuleDTO): EventsBaseModuleVM;

    protected toEventsBaseModuleDTO = (): IEventsBaseModuleDTO => {
        const displayUpcomingEvents = this.getBooleanValue(DISPLAY_UPCOMING_EVENTS);
        const displayPastEvents = this.getBooleanValue(DISPLAY_PAST_EVENTS);
        const description = this.getTrimmedStringValue(DESCRIPTION);
        const transpiledDescription = transpileClassesToInlineStyles(description);
        const isDefaultViewHidden = this.isDefaultViewHidden();

        return {
            positionOrder: this.getNumberValue(POSITION_ORDER),
            enabled: this.isEnabled(),
            label: this.getTrimmedStringValue(LABEL),
            displayLabel: this.getBooleanValue(DISPLAY_LABEL),
            description: transpiledDescription,
            displaySpeakers: this.getBooleanValue(DISPLAY_SPEAKERS),
            layout: this.getFormVmValuePropsByKey(LAYOUT).value as HubModuleLayout,
            ...(!isDefaultViewHidden && { defaultView: this.getFormVmValuePropsByKey(DEFAULT_VIEW).value as HubModuleDefaultView }),
            displayUpcomingEvents: displayUpcomingEvents,
            ...(displayUpcomingEvents && { upcomingEventDays: this.getNumberValue(UPCOMING_EVENTS_DAYS) }),
            displayPastEvents: displayPastEvents,
            ...(displayPastEvents && { pastEventDays: this.getNumberValue(PAST_EVENTS_DAYS) }),
        };
    };

    protected static fromEventsBaseModuleDTO<T extends IEventsBaseModuleDTO>(dto: T): T {
        const transpiledDescription = transpileInlineStylesToClasses(dto.description);
        return { ...dto, description: transpiledDescription };
    }
}
